import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import Validation from "@irati/utils/validation"

import ButtonRouterLink from "../ButtonRouterLink"

interface Props {
  onClick: () => void
}

class ValidationButtonRouterLink extends PureComponent<Props> {
  static contextTypes = {
    currentScreen: PropTypes.string
  }

  handleClick = (e) => {
    const {onClick} = this.props
    return Validation.validate(this.context.currentScreen).then(() => {
      return onClick(e)
    })
  }

  render() {
    return <ButtonRouterLink {...this.props} onClick={this.handleClick} />
  }
}

export default ValidationButtonRouterLink
